import React from 'react';
import { GenericListPage } from '../../../components/generic';
import { usePCountrys, PCountry } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';

const List: React.FC = () => {
  return (
    <GenericListPage<PCountry>
      useData={usePCountrys}
      config={{
        ...moduleConfig,
        getColumns,
        getToolbarIcon,
        getTableActions,
      }}
    />
  );
};

export default List;
